// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610051205/js/" + chunkId + "." + {"44":"04c9e708","225":"b7f60caf","481":"acdba712","486":"7c3d4437","770":"58f96cc8"}[chunkId] + ".0.00632091959786707.chunk.js";
};